import { createApp } from 'vue'
import { Store } from '../model/store/Store'
import VueScrollTo from 'vue-scrollto'
import MachineRootme2 from "../component/pages/machineIntroduction/MachineRootme2.vue";

const unsavedPuriCount = document.getElementById('unsavedPuriCount').textContent
const latestImageId = document.getElementById('latestImageId').textContent.replace(/\s+/g, '')
const isSearchableStr = document.getElementById('isSearchable').textContent
const isSearchable = isSearchableStr.toLowerCase() === "true"


Promise.all([
    Store.dispatch('AccountStoreV2/getAccountStatus'),
]).then(() => {
    createApp(
        MachineRootme2,
        {
            unsavedPuriCount: unsavedPuriCount,
            latestImageId: latestImageId,
            isSearchable: isSearchable,
        }
    )
    .use(Store)
    .use(VueScrollTo)
    .mount('#rootme2')
});
